import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { CollaboratorList } from "./components/CollaboratorList";
import { CollaboratorView } from "./components/CollaboratorView";

const NoMatch = () => (
    <div>
        <h2>Whoops</h2>
        <p>Sorry but this LHCONE collaborators URL didn’t find any pages</p>
    </div>
);

const LHCONE = () => {
    let { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/list`}>
                <CollaboratorList />
            </Route>
            <Route path={`${path}/view/:collaborator/:page?`}>
                <CollaboratorView />
            </Route>
            <Route path="*">
                <NoMatch />
            </Route>
        </Switch>
    );
};

export default LHCONE;
